export default __webpack_public_path__ + "static/media/smallColoredLogoPomelo.41ef3595.svg";